import { Button, colors, TableCell, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

import Label from "../../../Label";
import useAccountMetadata from "../../../hooks/useAccountMetadata";

const useStyles = makeStyles(() => ({
  label: {
    width: 120,
  },
  configRowDisabled: {
    background: "#FAFAFA",
  },
  configTextDisabled: {
    color: "#CCC",
  },
}));

export function DestinationConfigRow({
  name,
  labelColor,
  labelText,
  onOpenConfigModal,
  disabled = false,
  buttonText = "Configure",
  buttonComponent = null,
}) {
  const classes = useStyles();

  return (
    <TableRow className={clsx(disabled ? classes.configRowDisabled : "")}>
      <TableCell>
        <h5
          className={clsx(
            "text-md font-medium text-brand-navy",
            disabled ? classes.configTextDisabled : ""
          )}
        >
          {name}
        </h5>
      </TableCell>
      <TableCell align="center">
        {labelText && (
          <Label color={labelColor} className={clsx(classes.label)}>
            {labelText}
          </Label>
        )}
      </TableCell>
      <TableCell align="right">
        {!disabled &&
          (buttonComponent ? (
            buttonComponent
          ) : (
            <Button
              onClick={onOpenConfigModal}
              color="primary"
              variant="outlined"
            >
              {buttonText}
            </Button>
          ))}
      </TableCell>
    </TableRow>
  );
}

DestinationConfigRow.propTypes = {
  name: PropTypes.string.isRequired,
  labelColor: PropTypes.string,
  labelText: PropTypes.string,
  onOpenConfigModal: PropTypes.func.isRequired,
};

export function DestinationHIPAARow({
  onOpenConfigModal,
  disabled = false,
  buttonText = "Configure",
  buttonComponent = null,
  settings = {},
}) {
  const accountMetadata = useAccountMetadata();
  const classes = useStyles();

  if (!accountMetadata.config.hipaa) {
    return null;
  }

  return (
    <TableRow className={clsx(disabled ? classes.configRowDisabled : "")}>
      <TableCell>
        <h5
          className={clsx(
            "text-md font-medium text-brand-navy",
            disabled ? classes.configTextDisabled : ""
          )}
        >
          HIPAA Settings
        </h5>
      </TableCell>
      <TableCell align="center">
        <Label
          color={settings.haveBAA ? colors.green[600] : colors.grey[400]}
          className={clsx(classes.label)}
        >
          {settings.haveBAA ? "BAA In Place" : "No BAA"}
        </Label>
      </TableCell>
      <TableCell align="right">
        {!disabled &&
          (buttonComponent ? (
            buttonComponent
          ) : (
            <Button
              onClick={onOpenConfigModal}
              color="primary"
              variant="outlined"
            >
              {buttonText}
            </Button>
          ))}
      </TableCell>
    </TableRow>
  );
}

DestinationHIPAARow.propTypes = {
  onOpenConfigModal: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
};
